import React from "react";
import { Typography } from "antd";
import { formatMoney, formatMoneyAmount } from "~/utils/finance/money";

export type MoneyTextProps = {
  value?: number | string | null;
  /** When false, renders the number only (no FCFA). Default true. */
  showCurrency?: boolean;
  style?: React.CSSProperties;
  className?: string;
  strong?: boolean;
};

/** Shared display for money amounts: "100,000 FCFA" / "1,000.32 FCFA". */
export function MoneyText({
  value,
  showCurrency = true,
  style,
  className,
  strong,
}: MoneyTextProps) {
  const text = showCurrency
    ? formatMoney(value)
    : formatMoneyAmount(value);

  return (
    <Typography.Text strong={strong} style={style} className={className}>
      {text}
    </Typography.Text>
  );
}
